<template>
    <div>
      <img class="imgs" src="../../assets/whatapp.jpg" alt="">
    </div>
  </template>
  <script>
  export default {
    name: "App",
    components: {
    },
    data() {
      return {
      };
    },
    created() {
      // document.title = 'pocket'
    },
    mounted() {
    },
    methods: {
    },
  };
  
  </script>
  
  <style>
  * {
    margin: 0;
    padding: 0;
  }
  </style>